import "./App.css";
import { Resume } from "./components/Resume/Resume";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/:locale?" element={<Resume />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
